import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useEffect, useState } from "react";
import { useUser } from "./UserContext";
import { Databases, Query, Storage } from "appwrite";
import client from "./appwriteConfig";
import { v4 as uuidv4 } from "uuid";
import "./css/Home.css";
import { BsPlayFill, BsPauseFill } from "react-icons/bs";
import { BeatLoader } from "react-spinners";
import { FaShoppingCart } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import genres, { categorizedGenres } from "./genreBeat";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Select from "react-select";
import customStyles from "./css/StylesForSelect";
import Carousal from "./Carousal";
import AddBeatModal from "./AddBeatModal";
function Home() {
  const {
    user,
    cart,
    addToCart,
    fetchCartData,
    currentTrack,
    setCurrentTrack,
    isPlaying,
    togglePlay,
    cartLoading,
    startPlaylist,
  } = useUser();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("");
  const [selectedBeat, setSelectedBeat] = useState(null);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const genreOptions = genres.map((genre) => ({ value: genre, label: genre }));
  const styles = customStyles();
  useEffect(() => {
    if (user) {
      fetchCartData();
    }
  }, [user]);

  useEffect(() => {
    const fetchProducts = async () => {
      const database = new Databases(client, "default");
      try {
        const { documents } = await database.listDocuments(
          process.env.REACT_APP_DATABASE_ID,
          process.env.REACT_APP_COLLECTION_BEATS_ID,
          [Query.limit(1000)],
        );
        setProducts(documents);
        setLoading(false);
        // console.log(documents);
        // console.log("User after phone login:", user);
      } catch (error) {
        console.error("Failed to fetch products", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const isInCart = (productId) =>
    cart.some((item) => item.productId === productId);

  const handlePlayPause = (product) => {
    if (currentTrack && currentTrack.$id === product.$id) {
      togglePlay();
    } else {
      // ✅ set queue so Next/Prev knows what “next” is
      startPlaylist(filteredAndSortedProducts, product);
    }
  };
  const handleGenreChange = (selectedOptions) => {
    setSelectedGenres(selectedOptions || []);
  };

  const sortProducts = (a, b) => {
    if (sortBy === "cost-descending") {
      return b.cost - a.cost;
    } else if (sortBy === "cost-ascending") {
      return a.cost - b.cost;
    } else if (sortBy === "tempo-descending") {
      return b.bpm - a.bpm;
    } else if (sortBy === "tempo-ascending") {
      return a.bpm - b.bpm;
    } else {
      return 0;
    }
  };
  const filteredAndSortedProducts = products
    .filter(
      (product) =>
        selectedGenres.length === 0 ||
        selectedGenres.some((genre) => product.genre.includes(genre.value)),
    )
    .sort(sortProducts);

  const groupedByCategory = {};

  Object.entries(categorizedGenres).forEach(([category, genreList]) => {
    groupedByCategory[category] = filteredAndSortedProducts.filter((product) =>
      genreList.some((genre) => product.genre.includes(genre)),
    );
  });
  const handleAddToCart = (product) => {
    if (!isInCart(product.$id)) {
      const productWithType = {
        ...product,
        productType: "beat", // Add productType here
      };
      addToCart(productWithType); // Pass the product with productType set
    }
  };
  const smoothScroll = (element, distance, duration = 500) => {
    const start = element.scrollLeft;
    const startTime = performance.now();

    const easeInOut = (t) =>
      t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      element.scrollLeft = start + distance * easeInOut(progress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };
  return (
    <div className="home-list-container">
      {" "}
      <Carousal />
      <div className="beat-products">
        <div className="beats-hero-control">
          <div className="beats-hero-text">
            <h2>🎧 Hit Play & Find Your Next Banger</h2>
            <p>
              Scroll through fresh beats, preview instantly, and pick the sound
              that fits your vibe.
            </p>
          </div>

          <div className="beats-filter-panel">
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={genreOptions}
              onChange={handleGenreChange}
              value={selectedGenres}
              placeholder="Filter by Genres"
              classNamePrefix="filter-dropdown"
              className="filter-dropdown"
              styles={styles}
              menuPortalTarget={document.body}
            />

            <button
              type="button"
              className="beats-control-divider"
              onClick={() => {
                const firstBeat = filteredAndSortedProducts[0];
                if (firstBeat) {
                  handlePlayPause(firstBeat);
                }
              }}
            >
              ▶ Play • Preview
            </button>
            <select
              className="sorting-dropdown"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="">Sort by...</option>
              <option value="cost-descending">Cost: High to Low</option>
              <option value="cost-ascending">Cost: Low to High</option>
              <option value="tempo-descending">BPM: High to Low</option>
              <option value="tempo-ascending">BPM: Low to High</option>
            </select>
          </div>
        </div>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <BeatLoader color="#3498db" />
          </div>
        ) : products.length > 0 ? (
          <div className="document-grid-top">
            {Object.entries(groupedByCategory).map(
              ([category, beats]) =>
                beats.length > 0 && (
                  <div className="genre-section" key={category}>
                    <h3 className="genre-category-heading">{category}</h3>

                    <div className="genre-slider-wrapper">
                      <button
                        className="scroll-btn left"
                        onClick={() => {
                          const el = document.getElementById(
                            `genre-${category}`,
                          );
                          smoothScroll(el, -500, 550);
                        }}
                      >
                        ❮
                      </button>
                      <div id={`genre-${category}`} className="document-grid">
                        {beats.map((product) => (
                          <div key={uuidv4()} className="product-row">
                            <div className="product-image-beats">
                              <Link
                                to={`/beats/${product.beatName
                                  .replace(/\s+/g, "-")
                                  .toLowerCase()}`}
                              >
                                <img src={product.imageUrl} alt="Product" />
                              </Link>
                              <button
                                onClick={() => handlePlayPause(product)}
                                className="play-button-home"
                              >
                                {currentTrack?.$id === product.$id &&
                                isPlaying ? (
                                  <BsPauseFill />
                                ) : (
                                  <BsPlayFill />
                                )}
                              </button>
                            </div>
                            <div className="artist-beat-info">
                              <div className="product-info beat-name">
                                <Link
                                  to={`/beats/${product.beatName
                                    .replace(/\s+/g, "-")
                                    .toLowerCase()}`}
                                >
                                  <div className="beat-name-link">
                                    {product.beatName}
                                  </div>
                                </Link>
                              </div>
                              <div className="product-info artist-name">
                                {product.artistName}
                              </div>
                              <div className="product-info product-genre">
                                {product.genre}
                              </div>
                              <div className="product-info bpm">
                                {product.bpm} bpm
                              </div>
                            </div>
                            <div className="cost-cart-info">
                              <button
                                className="addCart-button"
                                onClick={() => setSelectedBeat(product)}
                                disabled={isInCart(product.$id)}
                              >
                                <div className="product-info cost">{` ₹${product.basicCost}`}</div>
                                <div className="cartbtn-add">
                                  {cartLoading[product.$id] ? (
                                    <ClipLoader size={7} color="#FFF" />
                                  ) : isInCart(product.$id) ? (
                                    <> In </>
                                  ) : (
                                    <> Add </>
                                  )}
                                  <FaShoppingCart />
                                </div>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>{" "}
                      <button
                        className="scroll-btn right"
                        onClick={() => {
                          const el = document.getElementById(
                            `genre-${category}`,
                          );
                          smoothScroll(el, 500, 550);
                        }}
                      >
                        ❯
                      </button>
                    </div>
                  </div>
                ),
            )}
            {selectedBeat && (
              <AddBeatModal
                product={selectedBeat}
                onClose={() => setSelectedBeat(null)}
              />
            )}
          </div>
        ) : (
          <p>No products found.</p>
        )}{" "}
      </div>
    </div>
  );
}

export default Home;
